export default "__VITE_ASSET__8v8$MuPv__"